import moment from 'moment'

export default function toHumanDate(dateString) {
  // const options = { dateStyle: 'medium', timeStyle: 'short', hourCycle: 'h23' }
  // return new Intl.DateTimeFormat(undefined, options).format(new Date(dateString))
  return moment(dateString).local().format('MMMM Do YYYY, HH:mm:ss')
}
